import type {
  Configuration,
  CreateOAuthAppRequest,
  CreateSessionRequest,
} from '@repo/api-gw-sdk';
import {
  AiAgentApi,
  AiAssistantApi,
  DashboardAssistantApi,
  OauthAppsApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

/**
 * The assistant a call is addressed to. It is also the URL segment that selects it: the
 * gateway decides which agent runs from the route, so this value is the whole address.
 */
export type AssistantApp = 'ai-assistant' | 'dashboard-assistant';

export const aiAgents = (httpClient: HttpClient, config: Configuration) => {
  const oauthAppsApi = new OauthAppsApi(config);
  const aiAgentApi = new AiAgentApi(config);
  const aiAssistantApi = new AiAssistantApi(config);
  const dashboardAssistantApi = new DashboardAssistantApi(config);

  return {
    useList: () =>
      httpClient.execute(
        oauthAppsApi.listOAuthApps.bind(oauthAppsApi),
        '/oauth-apps',
        ''
      ),
    create: (request: CreateOAuthAppRequest) =>
      oauthAppsApi.createOAuthApp(request),
    getAgentCard: () => aiAgentApi.getAIAgentCard(),
    createSession: (
      projectId: string,
      app: AssistantApp,
      request?: CreateSessionRequest
    ) =>
      app === 'dashboard-assistant'
        ? dashboardAssistantApi.createDashboardAssistantSession(
            projectId,
            request
          )
        : aiAssistantApi.createAiAssistantSession(projectId, request),
    getSession: (projectId: string, sessionId: string, app: AssistantApp) =>
      app === 'dashboard-assistant'
        ? dashboardAssistantApi.getDashboardAssistantSession(
            projectId,
            sessionId
          )
        : aiAssistantApi.getAiAssistantSession(projectId, sessionId),
  };
};
